import { useFreeTrialFirstVerifyModalStore } from "../components/modals/FreeTrialFirstVerifyModal"
import { useFreeTrialLimitModal } from "../components/modals/FreeTrialLimitModal"
import { useSubscriberInfo, useUserQuery } from "../networking/queries"
import { ANALYTIC_EVENTS } from "../util/analytics"
import { trackAnalyticEvent } from "../util/analytics"
import { sessionManager } from "../util/storage"

export const useSubscription = () => {
  const { user } = useUserQuery()
  const { onOpen: openFreeTrialModal } = useFreeTrialFirstVerifyModalStore()
  const { onOpen: openFreeTrialLimitModal } = useFreeTrialLimitModal()
  const { data: subscriberInfo } = useSubscriberInfo()

  const checkRemainingFreeQuests = ({
    numVerifying = 1,
    numCoachQuests = 0,
  }: {
    numVerifying?: number
    numCoachQuests?: number
  }) => {
    const hasActivePlan = subscriberInfo?.plan_is_active

    const numVerifyingWithoutCoachTasks = numVerifying - numCoachQuests

    const remainingFreeQuests =
      (user?.max_free_verified ?? 0) -
      (user?.num_quests_verified ?? 0) -
      numVerifyingWithoutCoachTasks

    if (hasActivePlan) return

    if (remainingFreeQuests < 0) {
      trackAnalyticEvent(ANALYTIC_EVENTS.SHOW_FREE_TRIAL_LIMIT_MODAL)
      throw openFreeTrialLimitModal(remainingFreeQuests)
    } else if (sessionManager.needsToSeeVerifyFreemiumPopup()) {
      trackAnalyticEvent(ANALYTIC_EVENTS.SHOW_FREE_TRIAL_FIRST_VERIFY_MODAL)
      throw openFreeTrialModal()
    }
  }

  return { checkRemainingFreeQuests }
}
